import { Identifier } from "../../id";
export class PromotionTypeId extends Identifier {
    constructor(id) {
        super("PromotionTypeId", id);
    }
}
